/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export default function createStateManager({
  initialCans = [],
  initialConfig = {},
  initialPreset = 'Big',
  presets = {}
} = {}) {
  const cansData = JSON.parse(JSON.stringify(initialCans || []));
  cansData.forEach(canItem => {
    if (canItem.paintLeft === undefined || canItem.paintLeft === null) {
      canItem.paintLeft = initialConfig.paintMax !== undefined ? initialConfig.paintMax : 10000;
    }
  });
  const config = {
    sprayRadius: initialConfig.sprayRadius !== undefined ? initialConfig.sprayRadius : 45,
    dotsPerTick: initialConfig.dotsPerTick !== undefined ? initialConfig.dotsPerTick : 5600,
    speedFactor: initialConfig.speedFactor !== undefined ? initialConfig.speedFactor : 1.5,
    lineScale: initialConfig.lineScale !== undefined ? initialConfig.lineScale : 0.65,
    paintMax: initialConfig.paintMax !== undefined ? initialConfig.paintMax : 10000,
    currentColor: initialConfig.currentColor !== undefined ? initialConfig.currentColor : '#ff3366',
    activeCanId: initialConfig.activeCanId !== undefined
      ? initialConfig.activeCanId
      : (cansData[0] && cansData[0].id) || 1
  };
  const activeInitialCan = cansData.find(c => c.id === config.activeCanId) || cansData[0];
  config.paintLeft = (activeInitialCan && typeof activeInitialCan.paintLeft === 'number')
    ? activeInitialCan.paintLeft
    : config.paintMax;
  const state = {
    cansData,
    config,
    dynamicRadius: config.sprayRadius,
    dynamicDensity: config.dotsPerTick,
    dynamicSpeed: config.lineScale,
    dynamicSpeedFactor: config.speedFactor,
    currentPreset: initialPreset,
    enableDrips: (presets && presets[initialPreset] && presets[initialPreset].enableDrips) || false,
    paintConsumption: (presets && presets[initialPreset] && presets[initialPreset].paintConsumption) || 1,
    presetConfig: (presets && presets[initialPreset]) || {},
    flatMode: false,
    isDrawing: false,
    lastSprayPos: null,
    lastSprayTime: null,
    dripMap: {},
    staticSprayMap: {},
    staticSprayStartTime: null,
    isStaticSpraying: false,
    lastStaticSprayPos: null,
    paintedPixels: new Set(),
    shownPaintEmptyAlerts: new Set(),
    onPaintUpdate: null,
    onUIUpdate: null,
    dirtyChunks: new Set(),
    options: { initialCans, initialConfig, initialPreset, presets, ...arguments[0] }
  };
  function markDirtyRegion(x, y, radius) {
    if (state.isPreview) return;
    const minCol = Math.max(0, Math.floor((x - radius) / 800));
    const maxCol = Math.min(4, Math.floor((x + radius) / 800));
    const minRow = Math.max(0, Math.floor((y - radius) / 800));
    const maxRow = Math.min(1, Math.floor((y + radius) / 800));
    for (let c = minCol; c <= maxCol; c++) {
      for (let r = minRow; r <= maxRow; r++) {
        state.dirtyChunks.add(`${c}_${r}`);
      }
    }
  }
  function syncPaintState(newCansData) {
    state.cansData.length = 0;
    JSON.parse(JSON.stringify(newCansData || [])).forEach(c => state.cansData.push(c));
    state.cansData.forEach(canItem => {
      if (canItem.paintLeft === undefined || canItem.paintLeft === null) {
        canItem.paintLeft = state.config.paintMax;
      }
    });
    const active = state.cansData.find(c => c.id === state.config.activeCanId) || state.cansData[0];
    if (active) {
      state.config.paintLeft = typeof active.paintLeft === 'number' ? active.paintLeft : state.config.paintMax;
    }
    if (typeof state.onUIUpdate === 'function') {
      state.onUIUpdate();
    }
  }
  function updateCanPaint(canId, paintUsed) {
    if (state.isPreview) return;
    const canIndex = state.cansData.findIndex(c => c.id === canId);
    if (canIndex !== -1) {
      const oldPaint = state.cansData[canIndex].paintLeft;
      const newPaint = Math.max(0, state.cansData[canIndex].paintLeft - paintUsed);
      state.cansData[canIndex].paintLeft = newPaint;
      if (typeof state.onPaintUpdate === 'function') {
        state.onPaintUpdate(canId, oldPaint, newPaint);
      }
      if (typeof window !== 'undefined' && typeof window.updatePaintLeft === 'function') {
        try { window.updatePaintLeft(canId, newPaint); } catch (e) { }
      }
    }
  }
  state.syncPaintState = syncPaintState;
  state.updateCanPaint = updateCanPaint;
  state.markDirtyRegion = markDirtyRegion;
  return state;
}
